<template>
  <SelectSeparator
    v-bind="delegatedProps"
    :class="cn(separatorVariants({ size: variants.size }), props.class)"
  />
</template>

<script setup>
import { computed, inject } from 'vue';
import { SelectSeparator } from 'radix-vue';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils.js';

const props = defineProps();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const variants = inject('select-variants');

const separatorVariants = cva(['h-px bg-primary-300'], {
  variants: {
    size: {
      sm: 'my-1',
      lg: 'my-1',
      xl: 'my-2',
    },
  },
});
</script>
